<template>
  <tooltip message="Mark as Primary Card">
    <v-btn
      color="primary"
      v-if="!item.is_primary"
      :loading="isLoading"
      icon
      @click="markPrimaryCard(item)"
    >
      <v-icon>mdi-credit-card-check</v-icon>
    </v-btn>
  </tooltip>
</template>
<script>
import {httpsCallable} from "firebase/functions";
import {functions} from "@/assets/utils/firebase.utils";
import Tooltip from "@/components/ui/Tooltip.vue";

export default {
  components: { Tooltip },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  inject: {
    fetchPaymentMethods: {
      default: () => null,
    },
  },
  methods: {
    async markPrimaryCard() {
      try {
        this.isLoading = true;
        let addMethod = httpsCallable(functions, "manageClientPaymentMethod");
        await addMethod({
          type: "update-primary",
          customer_id: this.$route.params.id,
          id: this.item.id,
        });
        if (this.fetchPaymentMethods) {
          await this.fetchPaymentMethods(false);
        }
        this.isLoading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>
